import { Navigate, useLocation } from "react-router";

/**
 * Redirects the legacy standalone `/patients/:id/balance/*` URLs to the
 * ClientPage tab route (`/energy-balance/*`) so the patient tabs are visible.
 */
const PatientBalanceRedirect = () => {
  const { pathname, search } = useLocation();

  return (
    <Navigate
      to={`${pathname.replace("/balance", "/energy-balance")}${search}`}
      replace
    />
  );
};

export default PatientBalanceRedirect;
